/* ══════════════════════════════════════════════════════════════════════════
   2D bracelet builder - MOBILE LAYOUT ONLY
   ──────────────────────────────────────────────────────────────────────────
   Restructures the builder for phones: pixiu / pearl / charm move out of the
   scrolling controls and become tap labels on the bracelet, each opening the
   same popup shell as the crystal picker, with an in-sheet info page behind
   a back button.

   This file NEVER runs above 860px - see the guard in apply(). The builder
   engine (pricing, cart, physics, crystal data) lives in
   bracelet-builder-2d.js and is untouched by this file: the real control
   rows are MOVED into the popup and moved back, never recreated, so their
   handlers and state stay intact.
   ══════════════════════════════════════════════════════════════════════════ */
(function(){
  var MOBILE = '(max-width: 860px)';
  // Hard guard. Above the breakpoint this file does nothing at all - no
  // listeners, no observers, no DOM changes - so desktop cannot regress.
  if(!window.matchMedia){ return; }
  function isMobile(){ return window.matchMedia(MOBILE).matches; }

  // Anchor on the stable inner ids, NOT on label text or DOM position: the
  // fields get moved into the sheet, so any position-based lookup breaks the
  // moment one is borrowed.
  var INNER={ crystal:'bb2d-crystalCells', pixiu:'bb2d-pixCells',
              pearl:'bb2d-spacerCells',   charm:'bb2d-charmStrip' };
  function fieldOf(kind){
    var inner=document.getElementById(INNER[kind]);
    return inner ? (inner.closest('.bb2d-field')||inner.parentElement) : null;
  }

  // one sheet, reused. Sections are MOVED in and moved back on close so the
  // builder keeps operating on its own live nodes.
  var sheet, body, titleEl, subEl, homes=[];
  function buildSheet(){
    if(sheet) return;
    sheet=document.createElement('div');
    sheet.className='bb2d-sheet'; sheet.hidden=true;
    // Same shell as the crystal picker (.lib-overlay > .lib): centred panel,
    // 24px heading, small subtitle, close top-right. Two different popup
    // shapes in one builder read as two different products.
    sheet.innerHTML='<div class="bb2d-sheet__panel" role="dialog" aria-modal="true">'
      +'<button type="button" class="bb2d-sheet__close" aria-label="Close">&times;</button>'
      +'<h2 class="bb2d-sheet__title"></h2>'
      +'<p class="bb2d-sheet__sub"></p>'
      +'<div class="bb2d-sheet__body"></div></div>';
    // Attach INSIDE .bb2d, not to <body>: the tile styling is all scoped
    // ".bb2d .cell .box .cl" etc, so a sheet outside that root loses every
    // rule and the names jumped from 9.5px to the 16px browser default.
    (document.querySelector('.bb2d') || document.body).appendChild(sheet);
    body=sheet.querySelector('.bb2d-sheet__body');
    titleEl=sheet.querySelector('.bb2d-sheet__title');
    subEl=sheet.querySelector('.bb2d-sheet__sub');
    sheet.querySelector('.bb2d-sheet__close').addEventListener('click',closeSheet);
    sheet.addEventListener('click',function(e){ if(e.target===sheet) closeSheet(); });
  }
  // ── in-sheet info view ──────────────────────────────────────────────────
  // Tapping a name shows its story in the SAME popup behind a back button.
  // A second popup over the first is the nested-modal trap we already hit.
  var savedView=null;
  // NEVER wipe body.innerHTML for an info page: the body holds MOVED live
  // control rows, and a snapshot-restore replaces them with dead copies and
  // destroys the real nodes - Back froze the charm sheet and killed Remove.
  // Hide the live children, overlay the info, unhide on Back.
  function ensureBack(){
    var back=sheet.querySelector('.bb2d-sheet__back');
    if(!back){
      back=document.createElement('button');
      back.type='button'; back.className='bb2d-sheet__back';
      back.innerHTML='&#8592; Back';
      back.addEventListener('click',restoreView);
      sheet.querySelector('.bb2d-sheet__panel').insertBefore(back, titleEl);
    }
    return back;
  }
  function showInfo(title, html){
    if(!sheet) return;
    savedView={ title:titleEl.textContent, sub:subEl?subEl.textContent:'',
                scroll:body.scrollTop };
    ensureBack().hidden=false;
    titleEl.textContent=title;
    if(subEl) subEl.textContent='';
    var old=body.querySelector(':scope > .bb2d-infoview'); if(old) old.remove();
    var iv=document.createElement('div'); iv.className='bb2d-infoview';
    iv.innerHTML=html;
    body.classList.add('bb2d-infomode');
    body.appendChild(iv);
    body.scrollTop=0;
  }
  // Some overlay pages are INTERACTIVE (the zodiac picker): copying their
  // HTML kills every listener, so the signs did nothing and the guardian
  // page never opened. Move the live nodes instead, and put them back home
  // when the page closes.
  var movedInfo=null;
  function showInfoNodes(title, nodes){
    if(!sheet) return;
    savedView={ title:titleEl.textContent, sub:subEl?subEl.textContent:'',
                scroll:body.scrollTop };
    ensureBack().hidden=false;
    titleEl.textContent=title;
    if(subEl) subEl.textContent='';
    var old=body.querySelector(':scope > .bb2d-infoview'); if(old) old.remove();
    var iv=document.createElement('div'); iv.className='bb2d-infoview';
    body.classList.add('bb2d-infomode');
    body.appendChild(iv);
    movedInfo=nodes.map(function(n){
      return { n:n, parent:n.parentNode, next:n.nextSibling }; });
    nodes.forEach(function(n){ iv.appendChild(n); });
    body.scrollTop=0;
  }
  function returnMovedNodes(){
    if(!movedInfo) return;
    movedInfo.forEach(function(r){
      if(r.parent) r.parent.insertBefore(r.n, r.next); });
    movedInfo=null;
  }
  function restoreView(){
    returnMovedNodes();
    var iv=body.querySelector(':scope > .bb2d-infoview'); if(iv) iv.remove();
    body.classList.remove('bb2d-infomode');
    if(!savedView) return;
    titleEl.textContent=savedView.title;
    if(subEl) subEl.textContent=savedView.sub;
    body.scrollTop=savedView.scroll;
    var back=sheet.querySelector('.bb2d-sheet__back');
    if(back) back.hidden=true;
    savedView=null;
  }
  // The builder ALREADY has one info overlay (#crystalInfoOverlay) that
  // crystals, charms and pearls all write into. Do NOT add a second one:
  // that stacked a popup on a popup. Instead let it populate as normal,
  // then move its content into this sheet as a page with a back button.
  // ── crystal picker: filters behind a button ─────────────────────────────
  // Three labelled dropdowns took a whole row above the grid. Collapse them
  // behind a toggle next to the search pill so the crystals start higher.
  function wireFilterToggle(){
    var top=document.querySelector('.bb2d-overlays .lib-top');
    var filters=document.querySelector('.bb2d-overlays .lib-filters');
    if(!top||!filters) return;
    // MOBILE ONLY. On desktop there is room for the three dropdowns, so the
    // toggle is just an extra click - and paint() runs at every width, so
    // without this the button was being injected on desktop too.
    if(!isMobile()){
      var stray=top.querySelector('.bb2d-filterToggle');
      if(stray) stray.remove();
      filters.classList.remove('is-open');
      return;
    }
    // Check the DOM, not a flag: paint() runs on every render and the flag
    // could be set on a since-replaced node, which produced two buttons.
    if(top.querySelector('.bb2d-filterToggle')) return;

    var btn=document.createElement('button');
    btn.type='button';
    btn.className='bb2d-filterToggle';
    btn.setAttribute('aria-expanded','false');
    btn.innerHTML='<svg viewBox="0 0 24 24" width="14" height="14" fill="none" aria-hidden="true">'
      +'<line x1="4" y1="7" x2="20" y2="7" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>'
      +'<line x1="7" y1="12" x2="17" y2="12" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>'
      +'<line x1="10" y1="17" x2="14" y2="17" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>'
      +'</svg><span>Filter</span>';
    // sits beside the search pill, before the filter block
    top.insertBefore(btn, filters);
  }
  // Delegated so it survives the picker being re-rendered: binding straight
  // to the button meant a later pass replaced the element and the listener
  // went with it, leaving a button that looked right and did nothing.
  // Delegated: paint() rebuilds .bb2d-taps, so a listener bound straight to
  // the centre button was thrown away on the next repaint - the target was
  // hit-testable but dead.
  document.addEventListener('click',function(e){
    var mid=e.target.closest && e.target.closest('.bb2d-centretap');
    if(mid){ e.preventDefault(); e.stopPropagation(); openSheet('crystal'); return; }
  });

  document.addEventListener('click',function(e){
    var btn=e.target.closest && e.target.closest('.bb2d-filterToggle');
    if(!btn) return;
    e.preventDefault(); e.stopPropagation();
    var filters=document.querySelector('.bb2d-overlays .lib-filters');
    if(!filters) return;
    var open=filters.classList.toggle('is-open');
    btn.classList.toggle('is-on',open);
    btn.setAttribute('aria-expanded',open?'true':'false');
  });
  window.BB2D_MOBILE_FILTERS=wireFilterToggle;

  // Take over any builder overlay that opens while our sheet is up, and show
  // its contents as a page inside the sheet instead. Otherwise it stacks a
  // popup on a popup, which on a phone has no clear way out.
  function hookOverlay(id, bodySel, fallbackTitle){
    var ov=document.getElementById(id);
    if(!ov || ov._bb2dHooked) return;
    ov._bb2dHooked=true;
    new MutationObserver(function(){
      if(!ov.classList.contains('open')) return;
      if(!sheet || sheet.hidden) return;          // not our flow, leave it
      var src=ov.querySelector(bodySel) || ov.querySelector('.zo-wrap') || ov;
      if(!src) return;
      ov.classList.remove('open');                 // hide the stacked layer
      // The copy often carries its own <h3>; do not repeat it as the page
      // title - that showed "MINI SILVER" twice.
      var h3=src.querySelector && src.querySelector('h3');
      showInfo(h3?'':fallbackTitle, src.innerHTML);
    }).observe(ov,{attributes:true,attributeFilter:['class']});
  }

  function rewireBody(){
    hookOverlay('bb2d-crystalInfoOverlay','[id$="crystalInfoBody"]','Details');
    // zodiac is interactive - move its LIVE grid+detail, never copy
    (function(){
      var ov=document.getElementById('bb2d-zodiacOverlay');
      if(!ov || ov._bb2dHooked) return;
      ov._bb2dHooked=true;
      new MutationObserver(function(){
        if(!ov.classList.contains('open')) return;
        if(!sheet || sheet.hidden) return;
        var grid=document.getElementById('bb2d-zodiacGrid');
        var det=document.getElementById('bb2d-zodiacDetail');
        if(!grid) return;
        ov.classList.remove('open');
        showInfoNodes('Choose your zodiac', det?[grid,det]:[grid]);
      }).observe(ov,{attributes:true,attributeFilter:['class']});
    })();
  }
  window.BB2D_MOBILE_REWIRE=rewireBody;

  function closeSheet(){
    returnMovedNodes();
    var iv=body&&body.querySelector(':scope > .bb2d-infoview'); if(iv) iv.remove();
    if(body) body.classList.remove('bb2d-infomode');
    // put every borrowed section back exactly where it came from
    homes.forEach(function(h){
      h.parent.insertBefore(h.node, h.next);
      if(isMobile()) h.node.classList.add('bb2d-m-hide');
    });
    homes=[];
    body.innerHTML='';
    sheet.hidden=true;
    document.body.style.overflow='';
    paint();
    // Run again on the next frame: the builder re-renders the ring after the
    // sheet closes, so a synchronous paint() reads the OLD pair state and the
    // pixiu / pearl labels stay where they were.
    requestAnimationFrame(function(){ paint(); });
    setTimeout(paint, 220);
  }
  function borrow(kind, label){
    var f=fieldOf(kind); if(!f) return;
    homes.push({node:f, parent:f.parentNode, next:f.nextSibling});
    // strip the hide class while it lives in the sheet, or the whole field
    // stays display:none and every tile measures 0x0
    f.classList.remove('bb2d-m-hide');
    var sec=document.createElement('div'); sec.className='bb2d-sheet__sec';
    if(label){ var h=document.createElement('p'); h.className='bb2d-sheet__group';
               h.textContent=label; sec.appendChild(h); }
    sec.appendChild(f);
    body.appendChild(sec);
  }
  function openSheet(kind){
    buildSheet();
    body.innerHTML=''; homes=[];
    if(kind==='crystal'){
      titleEl.textContent='Choose your crystals';
      // Crystals keep their own library popup; open that instead. Target the
      // ADD cell specifically - taking the first .cell opened the picker on
      // an empty ring but hit an already-chosen crystal once beads existed,
      // so tapping the middle of a built bracelet did nothing.
      if(typeof window.bb2dOpenLibrary==='function'){ window.bb2dOpenLibrary(); return; }
      var f=fieldOf('crystal');
      var add=f&&(f.querySelector('.pluscell,.cell.pluscell,.cell-add')
                  || f.querySelector('.cell:last-child'));
      if(add){ add.click(); return; }
      borrow('crystal',null);
    } else if(kind==='pearl'){
      titleEl.textContent='Choose your pearl';
      if(subEl) subEl.textContent='TAP A NAME FOR ITS STORY';
      addColourSwitch('pearl');
      borrow('pearl',null);
      addNone('pearl');
    } else if(kind==='charm'){
      titleEl.textContent='Choose your charm';
      if(subEl) subEl.textContent='TAP A NAME FOR ITS STORY';
      borrow('charm',null);
      addNone('charm');
    } else if(kind==='pixiu'){
      titleEl.textContent='Choose your pixiu';
      if(subEl) subEl.textContent='TAP A NAME FOR ITS STORY';
      addColourSwitch('pixiu');
      borrow('pixiu',null);
      addNone('pixiu');
    }
    var back=sheet.querySelector('.bb2d-sheet__back');
    if(back) back.hidden=true;
    savedView=null;
    sheet.hidden=false;
    document.body.style.overflow='hidden';
    rewireBody();
  }

  // "CLASSIC GOLD" - design and colour are separate spans in the tile
  // Returns {design, colour} so the label can put the colour on its own row
  function pixiuName(){
    var checked=document.querySelector('#bb2d-pixCells input:checked');
    if(!checked) return null;
    var cell=checked.closest('.cell'); if(!cell) return null;
    var cl=cell.querySelector('.cl'); if(!cl) return null;
    var design=[].slice.call(cl.childNodes)
      .filter(function(n){ return n.nodeType===3 && n.textContent.trim(); })
      .map(function(n){ return n.textContent.trim(); })[0]||'';
    var col=cell.querySelector('.pix-colour');
    return { design:design, colour:col?col.textContent.trim():'' };
  }
  // Two dragons put the PEARL at the centre front and push the pixiu out to
  // the sides, so the two labels have to trade places or each points at the
  // wrong piece.
  function hasPixiuPair(){
    var st=(window.bb2dState?window.bb2dState():null);
    return !!(st && st.pix && st.pix.img && st.pixCount>1);
  }

  // ALL | SILVER | GOLD in the sheet, mirroring the desktop title switcher.
  // Drives the engine through its API only - the strips rebuild on every
  // render, so poking their DOM would be lost work.
  function addColourSwitch(kind){
    var row=document.createElement('div'); row.className='bb2d-sheet-colsw';
    var cur=(window.bb2dColourFilterGet&&window.bb2dColourFilterGet(kind))||'ALL';
    row.innerHTML=['ALL','SILVER','GOLD'].map(function(c){
      return '<button type="button" class="bb2d-sheet-colsw-btn'+(c===cur?' on':'')
        +'" data-shcol="'+c+'">'+c+'</button>'; }).join('');
    row.addEventListener('click',function(e){
      var b=e.target.closest('[data-shcol]'); if(!b) return;
      e.preventDefault(); e.stopPropagation();
      if(window.bb2dColourFilter) window.bb2dColourFilter(kind, b.getAttribute('data-shcol'));
      row.querySelectorAll('.bb2d-sheet-colsw-btn').forEach(function(x){
        x.classList.toggle('on', x===b); });
    });
    body.appendChild(row);
  }

  // "None" - a shopper who wants no pearl or no charm needs a way to say so,
  // and to undo one they already picked.
  function addNone(kind){
    var row=document.createElement('div');
    row.className='bb2d-noneRow';
    var b=document.createElement('button');
    b.type='button'; b.className='bb2d-noneBtn';
    // "Remove" says what it does - "None" read as a choice in the list
    b.textContent='Remove';
    b.addEventListener('click',function(){
      clearSlot(kind);
      closeSheet();
    });
    row.appendChild(b);
    // Confirm closes the sheet - the choice is already applied live to the
    // bracelet, so this is a "done" affordance, not a separate commit.
    var ok=document.createElement('button');
    ok.type='button'; ok.className='bb2d-sheetConfirm';
    ok.textContent='Confirm';
    ok.addEventListener('click',closeSheet);
    row.appendChild(ok);
    body.appendChild(row);
  }
  // clear by clicking whatever the builder already exposes as a remove
  function clearSlot(kind){
    // Ask the builder to clear it. Unchecking an input and clicking a minus
    // button only moved the DOM around - the builder's own state never
    // changed, so Remove appeared to do nothing.
    if(typeof window.bb2dClearSlot==='function'){ window.bb2dClearSlot(kind); return; }
    var f=fieldOf(kind); if(!f) return;
    var sel=f.querySelector('input:checked');
    if(sel){ sel.checked=false; sel.dispatchEvent(new Event('change',{bubbles:true})); }
  }

  function chosen(kind){
    // Scope to the kind's OWN container, not its .bb2d-field wrapper: while
    // a sheet is open the borrowed rows share a parent, so a wrapper-level
    // query returned the pixiu's name for the pearl label ("Classic").
    var inner=document.getElementById(INNER[kind]);
    var f=inner||fieldOf(kind); if(!f) return null;
    var sel=f.querySelector('.cell input:checked, .is-selected, [aria-pressed="true"]');
    if(!sel) return null;
    var cell=sel.closest?(sel.closest('.cell')||sel):sel;
    var nm=cell.querySelector&&cell.querySelector('.cl');
    if(!nm) return 'Chosen';
    // .cl holds design + colour as separate spans that run together in
    // textContent ("CLASSICGOLD"); take just the design node's own text
    var first=[].slice.call(nm.childNodes).filter(function(n){
      return n.nodeType===3 && n.textContent.trim(); })[0];
    var t=(first?first.textContent:nm.textContent).trim().replace(/\s+/g,' ');
    return t ? t.charAt(0)+t.slice(1).toLowerCase() : 'Chosen';
  }

  // The arrange button lives in the CRYSTAL field's label row, which is
  // hidden on mobile - so it has to be relocated onto the stage rather than
  // recreated, or it loses its handler and its live pattern label.
  // Reset/undo relocate UNDER the add-to-cart button on mobile, as quiet
  // text - the icon circles at the stage top crowded the title area.
  function placeHistory(){
    var hist=document.getElementById('bb2d-history');
    var buy=document.querySelector('.bb2d-buy');
    if(!hist||!buy) return;
    if(isMobile()){
      // top right of the stage as before, but WORDS, not icon circles
      if(hist._bb2dHome && hist.parentElement===buy){
        hist._bb2dHome.p.insertBefore(hist, hist._bb2dHome.n);
      }
      hist.classList.add('bb2d-history--words');
      hist.classList.remove('bb2d-history--under');
      [['bb2d-reset','RESET'],['bb2d-undo','UNDO']].forEach(function(pair){
        var b=document.getElementById(pair[0]);
        if(b && !b._bb2dSvg){ b._bb2dSvg=b.innerHTML; b.textContent=pair[1]; }
      });
    } else {
      hist.classList.remove('bb2d-history--under','bb2d-history--words');
      if(hist._bb2dHome && hist.parentElement===buy){
        hist._bb2dHome.p.insertBefore(hist, hist._bb2dHome.n);
      }
      [['bb2d-reset'],['bb2d-undo']].forEach(function(pair){
        var b=document.getElementById(pair[0]);
        if(b && b._bb2dSvg){ b.innerHTML=b._bb2dSvg; b._bb2dSvg=null; }
      });
    }
  }
  function placeArrange(stage){
    var wrap=document.querySelector('.bb2d-arrange-wrap');
    if(!wrap) return;
    if(isMobile()){
      if(wrap.parentElement!==stage){
        if(!wrap._bb2dHome) wrap._bb2dHome={p:wrap.parentNode,n:wrap.nextSibling};
        stage.appendChild(wrap);
      }
      wrap.classList.add('bb2d-arrange--onstage');
    } else {
      wrap.classList.remove('bb2d-arrange--onstage');
      if(wrap._bb2dHome && wrap.parentElement===stage){
        wrap._bb2dHome.p.insertBefore(wrap, wrap._bb2dHome.n);
      }
    }
  }

  function paint(){
    wireFilterToggle();
    var stage=document.getElementById('bb2d-stage');
    var ring =document.getElementById('bb2d-ring');
    if(!stage||!ring) return;
    placeArrange(stage);
    var root=document.querySelector('.bb2d');
    if(root) root.classList.toggle('bb2d--mobile', isMobile());
    // The CRYSTAL row stays on the page exactly as the site has it - it
    // carries the chosen stones, their counts and the arrange control.
    // Only pixiu / pearl / charm move behind labels on the bracelet.
    ['pixiu','pearl','charm'].forEach(function(k){
      var f=fieldOf(k);
      if(f && !sheetHas(f)) f.classList.toggle('bb2d-m-hide', isMobile());
    });
    var cf=fieldOf('crystal'); if(cf) cf.classList.remove('bb2d-m-hide');
    var host=document.getElementById('bb2d-taps');
    if(!host){ host=document.createElement('div'); host.id='bb2d-taps';
               host.className='bb2d-taps'; stage.appendChild(host); }
    host.innerHTML='';
    if(!isMobile()) return;
    // compact (icon-only) as soon as the ring has beads - a full bracelet
    // has no room for worded pills
    var st=(window.bb2dState?window.bb2dState():null);
    var hasBeads=!!(st&&st.seq&&st.seq.length);
    host.classList.toggle('is-compact', hasBeads);
    var sb=stage.getBoundingClientRect(), rb=ring.getBoundingClientRect();
    var cx=rb.left-sb.left+rb.width/2, cy=rb.top-sb.top+rb.height/2;
    var rx=rb.width/2, ry=rb.height/2;
    // crystal + charm stacked in the CENTRE, pixiu down on the dragon
    var spots=[
      {k:'crystal', label:'TAP TO ADD CRYSTAL', x:cx, y:cy, text:true}
    ];

    // Pixiu is not a marker: its name sits as plain text under the dragon,
    // tappable to change. A + over the dragon hid the art it refers to.
    var paired=hasPixiuPair();
    var pname=pixiuName();
    var pbtn=document.createElement('button');
    pbtn.type='button'; pbtn.className='bb2d-pixname';
    if(paired){
      // Two dragons sit either SIDE of the centre pearl, so the label goes
      // out to the left where the pearl label lives when single - moving it
      // straight up just put it back on top of a dragon.
      var dyP=ry*0.60;
      var hcP=(Math.abs(dyP)<rx) ? Math.sqrt(rx*rx - dyP*dyP) : 0;
      pbtn.style.left=Math.round(cx - hcP - 8)+'px';
      pbtn.style.top =Math.round(cy + dyP)+'px';
      pbtn.classList.add('bb2d-pixname--side');
    } else {
      pbtn.style.left=Math.round(cx)+'px';
      pbtn.style.top =Math.round(cy+ry*1.06)+'px';
    }
    pbtn.innerHTML = pname
      ? '<span class="bb2d-pixname-design">'+pname.design+'</span>'
        +(pname.colour?'<span class="bb2d-pixname-colour">'+pname.colour+'</span>':'')
      : 'CHOOSE YOUR PIXIU';
    pbtn.addEventListener('click',function(e){ e.stopPropagation(); openSheet('pixiu'); });
    host.appendChild(pbtn);
    // No centre prompt of our own: the builder already renders
    // "TAP + TO CHOOSE YOUR CRYSTALS" there and two would overlap. Make its
    // own hint open the picker instead.
    var hint=document.getElementById('bb2d-ringHint');
    if(hint && !hint._bb2dWired){
      hint._bb2dWired=true;
      hint.style.pointerEvents='auto'; hint.style.cursor='pointer';
      hint.addEventListener('click',function(){ openSheet('crystal'); });
    }
    // The hint is display:none once the ring has beads, so wiring only the
    // hint left the middle of a built bracelet dead. Add an invisible target
    // over the centre - inside the ring, clear of the beads themselves.
    if(!host.querySelector('.bb2d-centretap')){
      var mid=document.createElement('button');
      mid.type='button'; mid.className='bb2d-centretap';
      mid.setAttribute('aria-label','Choose your crystals');
      var side=Math.round(Math.min(rx,ry)*0.90);
      mid.style.left=Math.round(cx)+'px';
      mid.style.top =Math.round(cy)+'px';
      mid.style.width=side+'px';
      mid.style.height=side+'px';
      // Bind here as well as the delegated handler: .bb2d-taps carries
      // pointer-events:none, and although the button re-enables it for
      // itself the event was not reaching document reliably.
      mid.addEventListener('click',function(e){
        e.preventDefault(); e.stopPropagation(); openSheet('crystal');
      });
      host.insertBefore(mid, host.firstChild);   // under the other labels
    }

    // Pearl and charm read as their own words beside the ring, each opening
    // its own sheet. A shopper who wants neither picks "None" in there.
    function sideLabel(kind, fallback, x, y, align){
      var name=chosen(kind);
      var b=document.createElement('button');
      b.type='button'; b.className='bb2d-slotlabel bb2d-slotlabel--'+align;
      b.style.left=Math.round(x)+'px'; b.style.top=Math.round(y)+'px';
      b.textContent=name||fallback;
      b.addEventListener('click',function(e){ e.stopPropagation(); openSheet(kind); });
      host.appendChild(b);
      // Clamp into the stage. "+ PEARL OF WISDOM" is 137px wide and ran
      // 17px off the left edge at the ring anchor, so measure and pull back
      // rather than guessing an inset.
      // Clamp into the stage on BOTH axes. Horizontally "+ PEARL OF WISDOM"
      // ran off the left; vertically "+ CHARM" sits above the ring and can
      // clip off the top of the stage depending on how tall the art is.
      var hb=host.getBoundingClientRect(), bb=b.getBoundingClientRect();
      var pad=6, dx=0, dy=0;
      if(bb.left < hb.left+pad)     dx = (hb.left+pad) - bb.left;
      if(bb.right > hb.right-pad)   dx = (hb.right-pad) - bb.right;
      if(bb.top < hb.top+pad)       dy = (hb.top+pad) - bb.top;
      if(bb.bottom > hb.bottom-pad) dy = (hb.bottom-pad) - bb.bottom;
      if(dx) b.style.left=Math.round(x+dx)+'px';
      if(dy) b.style.top =Math.round(y+dy)+'px';
    }
    // Charm sits ABOVE the ring, centred; pearl stays beside it. Short
    // wording so the label does not sprawl across the beads.
    sideLabel('charm','+ CHARM', cx, cy-ry*1.04, 'centre');
    // Sit the pearl label clear of the ring, not on top of it. At its own
    // height the circle reaches in to cx - sqrt(R^2 - dy^2), so anchor to
    // that edge with a small gap instead of guessing a fraction of the
    // radius - the old rx*0.62 overlapped the beads by 22px.
    (function(){
      var dy=ry*0.60;
      var halfChord=(Math.abs(dy)<rx) ? Math.sqrt(rx*rx - dy*dy) : 0;
      var x=cx - halfChord - 8;                  // 8px clear of the circle
      if(paired){
        // pearl is at the centre front now - put its label under the ring
        sideLabel('pearl','+ PEARL', cx, cy+ry*1.06, 'centre');
      } else {
        sideLabel('pearl','+ PEARL', x, cy+dy, 'right');
      }
    })();
  }
  function sheetHas(node){ return !!(body && body.contains(node)); }

  window.BB2D_MOBILE_APPLY=paint;

  // paint() rewrites the tap labels, which mutates the DOM, which woke this
  // observer, which called paint() again - a feedback loop that rebuilt
  // .bb2d-taps ~28 times a SECOND forever and made the whole page crawl.
  // Guard it: ignore anything paint() itself does, and ignore mutations
  // inside the nodes paint() owns.
  var painting=false;
  function paintGuarded(){
    if(painting) return;
    painting=true;
    // paint() is called DIRECTLY here, so wrapping window.BB2D_MOBILE_APPLY
    // from the box-row module never ran on repaints - the row rendered once
    // at load and went stale. Call the row/wrist/panel painters explicitly
    // (hoisted function declarations from the module below).
    try{ paint(); drawBoxRow(); drawWristLine(); placeHistory(); wireLibScrollbar(); wireNeedPills(); syncNeedPills(); } finally {
      // release only after the mutations from this paint have been queued
      requestAnimationFrame(function(){ painting=false; });
    }
  }
  var t=null;
  new MutationObserver(function(recs){
    if(painting) return;
    if(sheet&&!sheet.hidden) return;
    // our own furniture changing is not a reason to repaint
    for(var i=0;i<recs.length;i++){
      var n=recs[i].target;
      if(n && n.closest && n.closest('#bb2d-taps, #bb2d-boxrow, #bb2d-wristline, #bb2d-wristpop, #bb2d-sizepanel, .bb2d-sheet, .bb2d-arrange-wrap')) continue;
      clearTimeout(t); t=setTimeout(paintGuarded,140);
      return;
    }
  }).observe(document.documentElement,{childList:true,subtree:true});
  window.addEventListener('resize',paintGuarded);
  setTimeout(paintGuarded,1000);

  // Safari restores the previous scroll position on reload, so the page
  // reopened mid-bracelet and the title block sat above the screen. Start
  // at the top instead - this page IS the product, there is nothing above
  // the title worth restoring to.
  if(isMobile()){
    try{ history.scrollRestoration='manual'; }catch(_){}
    window.scrollTo(0,0);
    // iOS re-restores the old position at unpredictable moments (including
    // after the loading veil clears and layout settles), which cut the
    // title off. Keep pulling back to the top until the user touches or
    // 2.5s passes - whichever comes first.
    window.addEventListener('touchstart',function(){ window.__bb2dUserScrolled=true; },{once:true,passive:true});
    var tries=0;
    var tt=setInterval(function(){
      tries++;
      if(window.__bb2dUserScrolled || tries>10){ clearInterval(tt); return; }
      if(window.scrollY>0) window.scrollTo(0,0);
    },250);
    window.addEventListener('pageshow',function(){ if(!window.__bb2dUserScrolled) window.scrollTo(0,0); });
  }

  /* ─────────────────────────────────────────────────────────────────────────
     BOX ROW (Sarah & Sebastian layout, ported from the local mockup).
     Replaces the floating ring labels on mobile with a row of square dashed
     boxes UNDER the bracelet: one per chosen crystal, then pixiu/pearl/charm,
     then an ADD box. Reads the same bb2dState() the labels used; drives the
     builder only through its public API (bb2dClearSlot / openSheet).
     Lives in #bb2d-boxrow, which the MutationObserver above ignores, so it
     cannot restart the paint feedback loop.
  ───────────────────────────────────────────────────────────────────────── */
  var selBox=null;  // {kind:'crystal',id:'G-..'} | {kind:'pixiu'} ... - S&S: only the selected box shows its x
  function filesBase(){
    var d=document.getElementById('bb2d-data');
    try{ return (JSON.parse(d.textContent).filesBase)||''; }catch(e){ return ''; }
  }
  function crystalImg(id){ return filesBase()+id+'.png?width=160'; }

  function boxRowData(){
    var st=(window.bb2dState?window.bb2dState():null); if(!st) return null;
    var out={ crystals:[], pixiu:null, pearl:null, charm:null };
    // unique crystals in display order
    (st.order||[]).forEach(function(id){
      if((st.counts&&st.counts[id]||0)>0){
        var c=window.bb2dCrystalById?window.bb2dCrystalById(id):null;
        out.crystals.push({ id:id, name:(c&&(c.dname||c.name))||'Crystal',
          el:(c&&c.el)||'', img:crystalImg(id) });
      }
    });
    if(st.pix&&st.pix.img) out.pixiu={ img:st.pix.img, name:'Pixiu' };
    // pearl/charm photos come from the builder's own chosen cells - state
    // stores keys, not urls, and the DOM already resolved them
    // a pearl can be a spacer OR the centre of a pixiu pair - the pair case
    // has spacerPos empty, which left the pearl box showing "+" though a
    // pearl was clearly on the bracelet
    if((st.spacerPos&&st.spacerPos.length) || st.pairCentre==='pearl'){
      var pin=document.querySelector('#bb2d-spacerCells input:checked');
      var pim=pin&&pin.closest('.cell')&&pin.closest('.cell').querySelector('img');
      out.pearl={ name:'Pearl', img: pim?pim.src:null };
    }
    if(st.charms&&st.charms.length){
      var aim=document.querySelector('#bb2d-charmStrip .charm-card.attached img');
      out.charm={ name:'Charm', img: aim?aim.src:null };
    }
    return out;
  }

  function boxHost(){
    var host=document.getElementById('bb2d-boxrow');
    if(!host){
      host=document.createElement('div'); host.id='bb2d-boxrow';
      host.className='bb2d-boxrow';
      var stage=document.getElementById('bb2d-stage');
      // sits right after the bracelet stage
      if(stage&&stage.parentNode) stage.parentNode.insertBefore(host, stage.nextSibling);
      else (document.querySelector('.bb2d')||document.body).appendChild(host);
    }
    return host;
  }

  function drawBoxRow(){
    if(!isMobile()){ var h0=document.getElementById('bb2d-boxrow'); if(h0) h0.innerHTML=''; return; }
    var data=boxRowData(); if(!data) return;
    var host=boxHost();
    var cells=[];
    data.crystals.forEach(function(c){
      var on = selBox && selBox.kind==='crystal' && selBox.id===c.id;
      cells.push('<div class="bb2d-bwrap">'
        + '<div class="bb2d-box filled'+(on?' sel':'')+'" data-box="crystal" data-id="'+c.id+'">'
        +   '<img src="'+c.img+'" alt="">'
        +   (on?'<span class="bb2d-boxx" data-boxrm="crystal" data-id="'+c.id+'">&times;</span>':'')
        + '</div><span class="bb2d-boxlab">'+String(c.name).toUpperCase()+'</span></div>');
    });
    // ADD box - always present, opens the crystal picker
    cells.push('<div class="bb2d-bwrap">'
      + '<div class="bb2d-box" data-box="crystal"><span class="bb2d-boxplus">+</span></div>'
      + '<span class="bb2d-boxlab">ADD</span></div>');
    // single-choice slots
    [['pixiu','PIXIU'],['pearl','PEARL'],['charm','CHARM']].forEach(function(p){
      var k=p[0], c=data[k], on=selBox&&selBox.kind===k;
      cells.push('<div class="bb2d-bwrap">'
        + '<div class="bb2d-box'+(c?' filled':'')+(on?' sel':'')+'" data-box="'+k+'">'
        +   (c&&c.img?'<img src="'+c.img+'" alt="">':'<span class="bb2d-boxplus">+</span>')
        +   (c&&on?'<span class="bb2d-boxx" data-boxrm="'+k+'">&times;</span>':'')
        + '</div><span class="bb2d-boxlab">'+p[1]+'</span></div>');
    });
    var html=cells.join('');
    // skip identical rewrites: replacing the row mid-gesture detached the
    // element under the tester's finger, and the taps read as dead
    if(host._bb2dHtml!==html){ host.innerHTML=html; host._bb2dHtml=html; }
    // the desktop crystal strip's "CRYSTAL" label is noise once the box row
    // exists; the ARRANGE FOR ME button in the same row stays
    var cf=fieldOf('crystal');
    if(cf){ var lab=cf.querySelector('.bb2d-lab-row .lab');
      if(lab) lab.style.display='none'; }
    syncSizePanel();
  }

  /* Size panel: the desktop crystal strip is hidden on mobile; tapping a
     crystal box borrows the builder's OWN cell (live stepper + size buttons)
     into a small panel under the row. The container is moved, never cloned,
     so the builder keeps operating on its own nodes; visibility is re-applied
     every paint because renders rebuild the cells. */
  var ccHome=null;
  function sizePanelHost(){
    var p=document.getElementById('bb2d-sizepanel');
    if(!p){
      // a centred pop-out (same shell family as the wrist pop), holding the
      // website's own crystal card - photo, name, stepper, size row
      p=document.createElement('div'); p.id='bb2d-sizepanel';
      p.className='bb2d-sizepanel'; p.hidden=true;
      p.innerHTML='<div class="bb2d-sizecard">'
        +'<button type="button" class="bb2d-sizex" data-sizeclose>&times;</button>'
        +'<div class="bb2d-sizebody"></div>'
        +'<div class="bb2d-sizeenergy" hidden></div>'
        +'<div class="bb2d-sizefoot">'
        +'<button type="button" class="bb2d-sizeremove" data-sizeremove>Remove</button>'
        +'<button type="button" class="bb2d-sizedone" data-sizeclose>DONE</button>'
        +'</div></div>';
      p.addEventListener('click',function(e){
        if(e.target===p){ selBox=null; drawBoxRow(); } });
      (document.querySelector('.bb2d')||document.body).appendChild(p);
      // the main observer IGNORES this panel, so a builder rebuild inside it
      // (size/count taps wipe and recreate the cells) never re-synced -
      // energy vanished and every sibling cell un-hid ("box goes wider").
      // Local observer, re-entry guarded, re-syncs after each rebuild.
      var spSyncing=false;
      new MutationObserver(function(){
        if(spSyncing) return;
        if(p.hidden) return;
        spSyncing=true;
        requestAnimationFrame(function(){
          try{ syncSizePanel(); } finally {
            requestAnimationFrame(function(){ spSyncing=false; });
          }
        });
      }).observe(p,{childList:true,subtree:true});
    }
    return p;
  }
  document.addEventListener('click',function(e){
    if(e.target.closest&&e.target.closest('[data-sizeclose]')){
      selBox=null; drawBoxRow(); return; }
    if(e.target.closest&&e.target.closest('[data-sizeremove]')){
      if(selBox&&selBox.kind==='crystal'){
        var st=(window.bb2dState?window.bb2dState():null);
        var ids=[]; if(st) (st.order||[]).forEach(function(id){ if((st.counts[id]||0)>0) ids.push(id); });
        var idx=ids.indexOf(selBox.id);
        // the cell is inside the pop-out right now; its slot-x is the
        // builder's own remove
        var cell=document.querySelectorAll('#bb2d-crystalCells .cell.slotcell')[idx];
        var x=cell&&cell.querySelector('.slot-x');
        if(x) x.click();
      }
      selBox=null; drawBoxRow(); return; }
  });
  function syncSizePanel(){
    var cc=document.getElementById('bb2d-crystalCells'); if(!cc) return;
    var p=sizePanelHost();
    var open = isMobile() && selBox && selBox.kind==='crystal';
    var slot=p.querySelector('.bb2d-sizebody')||p;
    if(open){
      if(cc.parentNode!==slot){ ccHome={parent:cc.parentNode,next:cc.nextSibling}; slot.appendChild(cc); }
      var st=(window.bb2dState?window.bb2dState():null);
      var ids=[]; if(st) (st.order||[]).forEach(function(id){ if((st.counts[id]||0)>0) ids.push(id); });
      var idx=ids.indexOf(selBox.id);
      var cells=cc.querySelectorAll('.cell.slotcell');
      [].forEach.call(cc.children,function(ch){ ch.style.display='none'; });
      if(cells[idx]) cells[idx].style.display='';
      // the crystal's energies sit right under its NAME inside the card
      var en=p.querySelector('.bb2d-sizeenergy');
      if(!en){
        // a size/count tap makes the builder rebuild the cells with an
        // innerHTML wipe, which destroys the parked energy row - recreate
        en=document.createElement('div'); en.className='bb2d-sizeenergy';
        p.querySelector('.bb2d-sizecard').insertBefore(en, p.querySelector('.bb2d-sizefoot'));
      }
      if(en){
        var c=window.bb2dCrystalById?window.bb2dCrystalById(selBox.id):null;
        var ints=(c&&c.intentions)||[];
        if(ints.length){
          en.innerHTML=ints.map(function(i2){
            return '<span>'+String(i2).toUpperCase()+'</span>'; }).join('<i>&middot;</i>');
          en.hidden=false;
        } else en.hidden=true;
        var box=cells[idx]&&cells[idx].querySelector('.box');
        var cl=box&&box.querySelector('.cl');
        if(cl) box.insertBefore(en, cl.nextSibling);
        // the crystal's ELEMENT (icon + word) under the energies, same face
        var elr=p.querySelector('.bb2d-sizeel');
        if(!elr){ elr=document.createElement('div'); elr.className='bb2d-sizeel'; }
        var c3=window.bb2dCrystalById?window.bb2dCrystalById(selBox.id):null;
        if(c3&&c3.el){
          elr.innerHTML='<img src="/cdn/shop/t/30/assets/wuxing-'+c3.el
            +'.png" alt="">'+c3.el.toUpperCase();
          elr.hidden=false;
          if(en&&en.parentNode) en.parentNode.insertBefore(elr, en.nextSibling);
        } else elr.hidden=true;
      }
      p.hidden=false;
    } else {
      if(ccHome && cc.parentNode===slot){
        // the energy row is OUR node parked inside the borrowed cell - pull
        // it home first or it ships back to the desktop strip with the cell
        var en2=cc.querySelector('.bb2d-sizeenergy');
        if(en2) p.querySelector('.bb2d-sizecard').insertBefore(en2, p.querySelector('.bb2d-sizefoot'));
        var el2=cc.querySelector('.bb2d-sizeel');
        if(el2) p.querySelector('.bb2d-sizecard').insertBefore(el2, p.querySelector('.bb2d-sizefoot'));
        ccHome.parent.insertBefore(cc,ccHome.next); ccHome=null;
        [].forEach.call(cc.children,function(ch){ ch.style.display=''; });
      }
      p.hidden=true;
    }
  }

  // taps on the box row - delegated so it survives re-renders
  document.addEventListener('click',function(e){
    var t=e.target;
    var rm=t.closest&&t.closest('[data-boxrm]');
    if(rm){ e.preventDefault(); e.stopPropagation();
      var k=rm.getAttribute('data-boxrm');
      if(k==='crystal'){
        // remove only THIS crystal, via the builder's own cell remove button
        var st=(window.bb2dState?window.bb2dState():null);
        var ids=[]; if(st) (st.order||[]).forEach(function(id){ if((st.counts[id]||0)>0) ids.push(id); });
        var idx=ids.indexOf(rm.getAttribute('data-id'));
        var cell=document.querySelectorAll('#bb2d-crystalCells .cell.slotcell')[idx];
        var x=cell&&cell.querySelector('.slot-x');
        if(x) x.click();
      } else if(typeof window.bb2dClearSlot==='function') window.bb2dClearSlot(k);
      selBox=null; drawBoxRow(); syncSizePanel(); return; }
    var box=t.closest&&t.closest('[data-box]');
    if(box){ e.preventDefault(); e.stopPropagation();
      var k=box.getAttribute('data-box');
      var id=box.getAttribute('data-id');
      var empty=!box.classList.contains('filled');
      var already = selBox && selBox.kind===k && selBox.id===id;
      if(k==='crystal' && !empty){
        // tap toggles the size panel for this crystal; x removes it
        selBox = already ? null : {kind:'crystal', id:id};
        drawBoxRow(); syncSizePanel(); return;
      }
      // empty box or 2nd tap -> open the picker; 1st tap on a filled box selects
      if(empty || already){ selBox=null; syncSizePanel(); openSheet(k); return; }
      selBox={kind:k, id:id||null}; drawBoxRow(); return; }
  });

  /* ── one-line wrist size ─────────────────────────────────────────────────
     "EDIT WRIST SIZE" + the chosen size on ONE line above the bracelet.
     Tap -> pop-out with the size list; "How to measure" swaps the SAME
     pop-out to the site's size-guide copy (cloned from the section's own
     #bb2d-sizeGuideOverlay, so the text is exactly the website's) with a
     back button. Drives the builder through its own select + change event.
  ───────────────────────────────────────────────────────────────────────── */
  function wristSel(){ return document.getElementById('bb2d-wrist'); }
  function wristLine(){
    var line=document.getElementById('bb2d-wristline');
    if(!line){
      line=document.createElement('div'); line.id='bb2d-wristline';
      line.className='bb2d-wristline';
      // Serif title on top, then ONE line: EDIT WRIST SIZE with the chosen
      // size to its right.
      var t=document.querySelector('.bb2d-title');
      line.innerHTML='<div class="bb2d-wtitle">'+(t?t.textContent.trim():'')+'</div>'
        +'<div class="bb2d-wristrow">'
        +'<button type="button" class="bb2d-wristedit">EDIT WRIST SIZE</button>'
        +'<span class="bb2d-wristval"></span></div>';
      // BEFORE the history row, not between it and the stage: .bb2d-history
      // carries margin-bottom:-46px to pull the stage up under the circles,
      // and anything inserted in between gets swallowed by that overlap -
      // the size value rendered under the reset button.
      var hist=document.getElementById('bb2d-history');
      var stage=document.getElementById('bb2d-stage');
      var anchor=hist||stage;
      if(anchor&&anchor.parentNode) anchor.parentNode.insertBefore(line, anchor);
    }
    var st=(window.bb2dState?window.bb2dState():null);
    var v=line.querySelector('.bb2d-wristval');
    // write ONLY on change: an unconditional textContent write fires the
    // MutationObserver every paint, which schedules another paint - the
    // ~7Hz forever-loop that made every tap feel dead
    var want=(st&&st.wristLabel)||'';
    if(v && v.textContent!==want) v.textContent=want;
    return line;
  }
  function drawWristLine(){ if(isMobile()) wristLine(); }

  function wristPop(){
    var pop=document.getElementById('bb2d-wristpop');
    if(pop) return pop;
    pop=document.createElement('div'); pop.id='bb2d-wristpop';
    pop.className='bb2d-wristpop'; pop.hidden=true;
    pop.innerHTML=
      '<div class="bb2d-wristcard">'
      +'<div class="bb2d-wristpage" data-wpage="choices">'
      +  '<div class="bb2d-wristhead"><div>'
      +    '<div class="bb2d-wristtitle">Choose your wrist size</div>'
      +    '<div class="bb2d-wristhint">TAP A SIZE TO SELECT</div></div>'
      +    '<button type="button" class="bb2d-wristx" data-wclose>&times;</button></div>'
      +  '<div class="bb2d-wristlist"></div>'
      +  '<div class="bb2d-wristfoot">'
      +    '<button type="button" class="bb2d-wristhelp" data-whelp>How to measure</button>'
      +    '<button type="button" class="bb2d-wristdone" data-wclose>DONE</button></div>'
      +'</div>'
      +'<div class="bb2d-wristpage" data-wpage="help" hidden>'
      +  '<div class="bb2d-wristhead">'
      +    '<button type="button" class="bb2d-wristback" data-wback>&larr; Back</button>'
      +    '<button type="button" class="bb2d-wristx" data-wclose>&times;</button></div>'
      +  '<div class="bb2d-wristhelpbody"></div>'
      +'</div></div>';
    (document.querySelector('.bb2d')||document.body).appendChild(pop);
    return pop;
  }
  function openWristPop(){
    var sel=wristSel(); if(!sel) return;
    var pop=wristPop();
    var list=pop.querySelector('.bb2d-wristlist');
    var cur=sel.options[sel.selectedIndex]?sel.options[sel.selectedIndex].textContent:'';
    list.innerHTML=[].map.call(sel.options,function(o){
      var on=o.textContent===cur;
      return '<button type="button" class="bb2d-wristopt'+(on?' on':'')+'" data-wval="'+o.value+'">'
        +'<span>'+o.textContent+'</span><span class="tick">&#10003;</span></button>';
    }).join('');
    // help body: clone the site's own size guide copy the first time
    var help=pop.querySelector('.bb2d-wristhelpbody');
    if(help&&!help.childNodes.length){
      var src=document.querySelector('#bb2d-sizeGuideOverlay .sg-lib');
      if(src){
        var clone=src.cloneNode(true);
        var x=clone.querySelector('.lib-close'); if(x) x.remove();
        help.appendChild(clone);
      } else help.innerHTML='<p>See the size guide on the product page.</p>';
    }
    pop.querySelector('[data-wpage="choices"]').hidden=false;
    pop.querySelector('[data-wpage="help"]').hidden=true;
    pop.hidden=false;
  }
  document.addEventListener('click',function(e){
    var t=e.target;
    if(t.closest&&t.closest('.bb2d-wristedit')){ e.preventDefault(); openWristPop(); return; }
    var pop=document.getElementById('bb2d-wristpop');
    if(!pop||pop.hidden) return;
    var opt=t.closest&&t.closest('[data-wval]');
    if(opt){
      var sel=wristSel();
      if(sel){ sel.value=opt.getAttribute('data-wval');
        sel.dispatchEvent(new Event('change',{bubbles:true})); }
      openWristPop();               // re-render list to move the tick
      drawWristLine();
      return; }
    if(t.closest&&t.closest('[data-whelp]')){
      pop.querySelector('[data-wpage="choices"]').hidden=true;
      pop.querySelector('[data-wpage="help"]').hidden=false; return; }
    if(t.closest&&t.closest('[data-wback]')){
      pop.querySelector('[data-wpage="help"]').hidden=true;
      pop.querySelector('[data-wpage="choices"]').hidden=false; return; }
    if(t.closest&&t.closest('[data-wclose]')){ pop.hidden=true; return; }
  });

  /* ── crystal story INSIDE the library panel (mobile) ────────────────────
     Tapping a name used to stack a second floating card over the library -
     popup on popup. On mobile the story now takes over the SAME panel with
     a back arrow, like every other in-sheet page. Content is copied (text
     and image only, no listeners needed); the ci overlay never shows. */
  (function(){
    var ov=document.getElementById('bb2d-crystalInfoOverlay');
    if(!ov || ov._bb2dLibHook) return;
    ov._bb2dLibHook=true;
    function libPanel(){ var l=document.querySelector('.bb2d-overlays .lib-overlay.open .lib');
      return l&&!l.closest('#bb2d-crystalInfoOverlay')?l:null; }
    new MutationObserver(function(){
      if(!isMobile()) return;
      if(!ov.classList.contains('open')) return;
      var lib=libPanel(); if(!lib) return;   // not from the library - leave it
      ov.classList.remove('open');
      var body=document.getElementById('bb2d-crystalInfoBody');
      var story=lib.querySelector(':scope > .bb2d-libstory');
      if(!story){
        story=document.createElement('div'); story.className='bb2d-libstory';
        lib.appendChild(story);
      }
      story.innerHTML='<button type="button" class="bb2d-libstory-back">&#8592; Back</button>'
        +(body?body.innerHTML:'');
      lib.classList.add('lib--story');
      story.scrollTop=0;
    }).observe(ov,{attributes:true,attributeFilter:['class']});
    document.addEventListener('click',function(e){
      var t=e.target;
      if(t.closest&&t.closest('.bb2d-libstory-back')){
        e.preventDefault(); e.stopPropagation();
        var lib=t.closest('.lib');
        var st=lib&&lib.querySelector(':scope > .bb2d-libstory');
        if(st) st.remove();
        if(lib) lib.classList.remove('lib--story');
      }
    });
  })();

  /* ── custom scroll thumb for the crystal library ────────────────────────
     iOS Safari IGNORES ::-webkit-scrollbar and scrollbar-color entirely, so
     three rounds of CSS "fixes" changed nothing on a real iPhone. Draw our
     own thumb: native bar hidden in CSS, this div tracks scrollTop. */
  function wireLibScrollbar(){
    // MOBILE ONLY: on desktop this span has no styling (the rules live in
    // the mobile media query), so it joined the flex column as a plain
    // block UNDER the grid - the mystery white band at the bottom of the
    // desktop crystal pop-out.
    if(!isMobile()){
      document.querySelectorAll('.bb2d-scrollthumb').forEach(function(t){ t.remove(); });
      return;
    }
    // Runs EVERY paint: the library panel gets rebuilt, which detached the
    // first thumb along with its parent - the current grid then had none
    // and the bar looked native/white again. Re-find, re-attach, clean up.
    document.querySelectorAll('.bb2d-scrollthumb').forEach(function(t){
      if(!t.parentElement || !t.parentElement.isConnected
         || !t.parentElement.querySelector('.lib-grid, #bb2d-libGrid')) t.remove();
    });
    var grid=document.getElementById('bb2d-libGrid')
          || document.querySelector('.bb2d-overlays .lib-grid');
    if(!grid) return;
    var wrap=grid.parentElement;
    if(getComputedStyle(wrap).position==='static') wrap.style.position='relative';
    var th=wrap.querySelector(':scope > .bb2d-scrollthumb');
    if(!th){
      // a SPAN, not a div: base.css nukes every empty div site-wide
      // (div:empty{display:none}), which is why a styled, synced thumb
      // still rendered at 0x0
      th=document.createElement('span'); th.className='bb2d-scrollthumb';
      wrap.appendChild(th);
      var sync=function(){
        var sh=grid.scrollHeight, ch=grid.clientHeight;
        if(sh<=ch+4){ th.style.opacity='0'; return; }
        var gr=grid.getBoundingClientRect(), wr=wrap.getBoundingClientRect();
        var track=gr.height, h=Math.max(28, track*ch/sh);
        th.style.height=Math.round(h)+'px';
        th.style.top=Math.round((gr.top-wr.top)+(track-h)*(grid.scrollTop/(sh-ch)))+'px';
        th.style.opacity='1';
      };
      th._bb2dSync=sync;
      grid.addEventListener('scroll',sync,{passive:true});
      new ResizeObserver(sync).observe(grid);
    }
    if(th._bb2dSync) th._bb2dSync();
  }

  /* ── "You need" element pills in the crystal library ────────────────────
     Under the search row, when a bazi reading is saved: the wearer's
     priority elements, ranked, each as a tappable pill with its emotion.
     Tapping one filters the library to that element via the builder's API. */
  var EL_EMOTION={ wood:'growth', fire:'joy', earth:'stability',
                   metal:'clarity', water:'calm' };
  function syncNeedPills(){
    var sel=document.getElementById('bb2d-fEl');
    if(!sel) return;
    var cur=String(sel.value||'').toLowerCase();
    document.querySelectorAll('.bb2d-needpill').forEach(function(x){
      x.classList.toggle('on', !!cur && x.getAttribute('data-needel')===cur);
    });
  }
  function wireNeedPills(){
    var top=document.querySelector('.bb2d-overlays .lib-top');
    if(!top || !isMobile()) return;
    var host=top.parentElement;
    if(host.querySelector('.bb2d-needrow')) return;
    var r=null;
    try{ var raw=localStorage.getItem('serenity_bazi');
      if(raw){ var o=JSON.parse(raw); r=o&&o.reading; } }catch(_){}
    if(!r || !r.like || !r.like.length) return;
    var row=document.createElement('div'); row.className='bb2d-needrow';
    row.innerHTML='<span class="bb2d-needlab">You need:</span>'
      + r.like.slice(0,3).map(function(e,i){
          var el=String(e).toLowerCase();
          return '<button type="button" class="bb2d-needpill" data-needel="'+el+'">'
            +'<img src="/cdn/shop/t/30/assets/wuxing-'+el+'.png" alt="">'
            +(i+1)+'. '+el.charAt(0).toUpperCase()+el.slice(1)
            +'</button>';
        }).join('');
    top.parentNode.insertBefore(row, top.nextSibling);
  }
  document.addEventListener('click',function(e){
    var p2=e.target.closest&&e.target.closest('[data-needel]');
    if(!p2) return;
    e.preventDefault(); e.stopPropagation();
    if(typeof window.bb2dSetElementFilter==='function')
      window.bb2dSetElementFilter(p2.getAttribute('data-needel'));
    syncNeedPills();
  });
  // the element dropdown (native select behind the dd) - "All elements"
  // must clear the pill highlight the moment it is chosen, not on the next
  // repaint, which sometimes never came
  document.addEventListener('change',function(e){
    if(e.target && e.target.id==='bb2d-fEl') syncNeedPills();
  });
  // the dd items write the select without always firing change - wrap the
  // public setter so every path lands on the same sync
  (function(){
    var t=setInterval(function(){
      if(typeof window.bb2dSetElementFilter!=='function') return;
      clearInterval(t);
      var orig=window.bb2dSetElementFilter;
      window.bb2dSetElementFilter=function(el){ orig(el); syncNeedPills(); };
    },300);
  })();

  // hook the box row + wrist line onto every paint, after the labels draw
  var _origApply=window.BB2D_MOBILE_APPLY;
  window.BB2D_MOBILE_APPLY=function(){ if(_origApply) _origApply(); drawBoxRow(); drawWristLine(); };
  setTimeout(function(){ drawBoxRow(); drawWristLine(); },1100);
})();

